import { render, staticRenderFns } from "./TransferenciaItemsIngreso.vue?vue&type=template&id=193a4470&scoped=true&"
import script from "./TransferenciaItemsIngreso.vue?vue&type=script&lang=js&"
export * from "./TransferenciaItemsIngreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a4470",
  null
  
)

export default component.exports